module.exports = __webpack_public_path__ + "static/media/ms.dfcc847d.png";